import React, { useContext } from 'react';
import { MealPlanSubscriptionContext } from 'src/pages/consumer/meal-plans/MealPlanSubscriptionsContext';
import { ActiveSubscriberPageWrapper } from './ActiveSubscriberPage';
import { NonSubscriberPage } from './NonSubscriberPage';

interface WeeklyShefServicePageProps {}

export const WeeklyShefServicePage: React.FC<WeeklyShefServicePageProps> = () => {
  const { userHasActiveMealPlan } = useContext(MealPlanSubscriptionContext);
  return userHasActiveMealPlan ? <ActiveSubscriberPageWrapper /> : <NonSubscriberPage />;
};
